export default __webpack_public_path__ + "static/media/alpha.5f792a8e.svg";